import React, { ButtonHTMLAttributes } from "react";
import { useFormContext } from "react-hook-form";
import { mergeClassNames } from "../../../utils/style";

type ButtonType =
  | { type: "submit"; onClick?: never }
  | {
      type?: Omit<ButtonHTMLAttributes<HTMLButtonElement>["type"], "submit">;
      onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    };

type Props = ButtonType & {
  text: string;
  disabled?: boolean;
  className?: string;
  type?: ButtonHTMLAttributes<HTMLButtonElement>["type"];
};

export const CustomButton: React.FC<Props> = ({
  text,
  type,
  className,
  disabled,
  ...props
}: Props) => {
  const formContext = useFormContext();

  return (
    <button
      type={type ?? "button"}
      disabled={
        type === "submit"
          ? !formContext?.formState.isValid ||
            formContext.formState.isSubmitting
          : disabled
      }
      className={mergeClassNames(
        "px-10 py-3 disabled:bg-gray-border whitespace-nowrap bg-primary text-white disabled:cursor-not-allowed rounded",
        className
      )}
      {...props}
    >
      {text}
    </button>
  );
};
